import "./Tela01.styles.css";
import logoInovae from "../../img/logoInovae.svg";
import logoSenai from "../../img/logoSenai.svg";
import seta from "../../img/seta.png";
import primeiraPess from "../../img/a01.png";
import segundaPess from "../../img/o02.jpeg";
import terceiraPess from "../../img/a03.jpeg";
import estrela from "../../img/estrela.svg";


export default function Tela1(){
    
    const irParaVencedor = (id) => {
    const elemento = document.getElementById(`vencedor-${id}`);

    if (elemento) {
            elemento.scrollIntoView({
            behavior: "smooth",
            block: "center",
            });
        }
    };

    const irParaTela02 = () => {
    const elemento = document.getElementById("tela02");

    if (elemento) {
            elemento.scrollIntoView({
            behavior: "smooth",
            block: "start",
            });
        }
    };

    return(
        <section className="tela01">

            <div className="tela01__container">

                <div className="tela01_top">
                    <img style={{width: "147px"}} src={logoInovae} alt="Inovaê Docente" className="tela01_logoInovae" />
                    <img style={{width: "147px"}} src={logoSenai} alt="SENAI"  className="tela01_logoSenai" />
                </div>

                <div className="tela01_ranking">
                    <div className="pessoa pessoa_segundo" onClick={() => irParaVencedor(2)}>
                        {/* <div className="pessoa_star">★</div> */}
                        <img src={estrela} alt="Estrela"  className="estrela_foto" />
                        <img src={segundaPess} alt="Alexandro Cruz"  className="pessoa_foto" />
                        {/* <img src="/pessoa2.png" alt="Alexandro Cruz" className="pessoa_foto" /> */}
                        <span className="pessoa_position">2º Lugar - 94,67</span>
                        <h3>Herberth Vilaronga</h3>
                        <p>SENAI JUAZEIRO</p>
                        <div className="pessoa_link">
                            <span>Ver vídeo pich!</span>
                            <span className="pessoa_linkArrow">→</span>
                        </div>
                    </div>

                    <div className="pessoa pessoa_primeiro" onClick={() => irParaVencedor(1)}>
                        {/* <div className="pessoa_star">★</div> */}
                        <img src={estrela} alt="Estrela"  className="estrela_fotoPrin" />
                        <img src={primeiraPess} alt="Andressa Souza"  className="pessoa_foto" />
                        {/* <img src="/pessoa1.png" alt="Andressa Souza" className="pessoa_foto" /> */}
                        <span className="pessoa_position">1º Lugar - 95,33</span>
                        <h3>Danielle Guimarães</h3>
                        <p>SENAI SUDOESTE</p>
                        <div className="pessoa_link">
                            <span>Ver vídeo pich!</span>
                            <span className="pessoa_linkArrow">→</span>
                        </div>
                    </div>

                    <div className="pessoa pessoa_terceiro" onClick={() => irParaVencedor(3)}>
                        {/* <div className="pessoa_star">★</div> */}
                        <img src={estrela} alt="Estrela"  className="estrela_foto" />
                        <img src={terceiraPess} alt="Sofia Mendonça"  className="pessoa_foto" />
                        {/* <img src="/pessoa3.png" alt="Sofia Mendonça" className="pessoa_foto" /> */}
                        <span className="pessoa_position">3º Lugar - 90,67</span>
                        <h3>Fábio Costa</h3>
                        <p>SENAI LAURO DE FREITAS</p>
                        <div className="pessoa_link">
                            <span>Ver vídeo pich!</span>
                            <span className="pessoa_linkArrow">→</span>
                        </div>

                    </div>
                </div>

                <h2 style={{color: "#EBEBEB"}} className="tela01_titulo">As 3 Melhores Práticas Inovaê Docente 2025!</h2>

                <div className="seta_arrow" onClick={irParaTela02}>
                    <img src={seta} alt="SENAI"  className="setaSeta" />
                </div>

            </div>

        </section>


    )


}